import { cloneElement } from 'react'
import { usePermissions } from 'react-admin';

/**
 * Mostra `children` se o usuário tiver QUALQUER uma das permissões (OR, `some`).
 * Em volta de um SubMenu, a lista precisa ter a permissão de cada item de dentro
 * (teste: src/containers/Menu/menuPermissions.test.ts).
 * @param {{ permissions?: string[], children: import('react').ReactElement, [prop: string]: any }} props
 */
const Permissions = ({ permissions = [], children, ...props }) => {
  const { permissions: userPermissions } = usePermissions();
  return userPermissions && permissions.some(r => userPermissions.includes(r)) ? cloneElement(children, props) : null
}
export default Permissions;
